(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["edible-moods"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();
  function init(root = document) {
    root.querySelectorAll('[data-edible-edit]').forEach(section => {
      if (instances.has(section)) return;
      const tabs = [...section.querySelectorAll('[data-edible-tab]')];
      const cards = [...section.querySelectorAll('[data-edible-card]')];
      const tablist = section.querySelector('[role="tablist"]');
      const mobile = matchMedia('(max-width: 760px)');
      let active = 0;
      function update(index = active, focus = false) {
        active = index;
        tablist.hidden = !mobile.matches || tabs.length < 2;
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === active));
          tab.tabIndex = i === active ? 0 : -1;
        });
        cards.forEach((card, i) => {
          card.hidden = mobile.matches && i !== active;
          if (mobile.matches && tabs.length > 1) {
            card.setAttribute('role', 'tabpanel');
            card.setAttribute('aria-labelledby', tabs[i].id);
          } else {
            card.removeAttribute('role');
            card.setAttribute('aria-labelledby', card.querySelector('h3').id);
          }
        });
        if (focus) tabs[active].focus();
      }
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => update(i));
        tab.addEventListener('keydown', event => {
          const next = {ArrowRight:(i+1)%tabs.length, ArrowLeft:(i-1+tabs.length)%tabs.length, Home:0, End:tabs.length-1}[event.key];
          if (next === undefined) return;
          event.preventDefault(); update(next, true);
        });
      });
      const resize = () => update();
      mobile.addEventListener('change', resize);
      instances.set(section, {update, cards, cleanup: () => mobile.removeEventListener('change', resize)});
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-edible-edit]').forEach(section => {instances.get(section)?.cleanup();instances.delete(section)}));
  document.addEventListener('shopify:block:select', event => {
    const card = event.target.closest('[data-edible-card]');
    const state = card && instances.get(card.closest('[data-edible-edit]'));
    if (state) state.update(state.cards.indexOf(card));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flower-description"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('flower-description')) {
  customElements.define('flower-description', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized || !this.hasAttribute('data-collapse')) return;
      this.initialized = true;
      const copy = this.querySelector('.flower-about__copy');
      const button = this.querySelector('button');
      let expanded = false;
      const update = () => {
        const limit = parseFloat(getComputedStyle(this).getPropertyValue('--flower-preview'));
        const long = copy.scrollHeight > limit + 20;
        button.hidden = !long;
        this.classList.toggle('is-collapsed', long && !expanded);
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? button.dataset.less : button.dataset.more;
      };
      button.addEventListener('click', () => { expanded = !expanded; update(); });
      copy.addEventListener('focusin', () => { expanded = true; update(); });
      this.observer = new ResizeObserver(update);
      this.observer.observe(copy);
      update();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.initialized = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiktok-offer"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.addEventListener('click', async (event) => {
    const copy = event.target.closest('[data-tt-copy]');
    if (copy) {
      const campaign = copy.closest('[data-tt-campaign]');
      const status = campaign?.querySelector('[data-tt-status]');
      try {
        await navigator.clipboard.writeText(copy.dataset.ttCopy);
        copy.querySelector('[data-tt-copy-text]').textContent = copy.dataset.copiedLabel;
        if (status) status.textContent = `${copy.dataset.ttCopy} — ${campaign?.dataset.copySuccess || 'Copied'}`;
        setTimeout(() => { if (copy.isConnected) copy.querySelector('[data-tt-copy-text]').textContent = copy.dataset.copyLabel; }, 2400);
      } catch {
        if (status) status.textContent = `${campaign?.dataset.copyFallback || 'Select and copy this code:'} ${copy.dataset.ttCopy}`;
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(copy.querySelector('strong'));
        selection.removeAllRanges(); selection.addRange(range);
      }
    }
    const motion = event.target.closest('[data-tt-motion]');
    if (motion) {
      const paused = motion.closest('[data-tt-campaign]').classList.toggle('tt-paused');
      motion.setAttribute('aria-pressed', String(paused));
      const campaign = motion.closest('[data-tt-campaign]');
      motion.setAttribute('aria-label', paused ? (campaign.dataset.playLabel || 'Play artwork motion') : (campaign.dataset.pauseLabel || 'Pause artwork motion'));
      motion.textContent = paused ? '▷' : 'Ⅱ';
    }
    const piece = event.target.closest('[data-tt-art]');
    const dialog = document.querySelector('[data-tt-dialog]');
    if (piece && dialog) {
      dialog.querySelector('[data-tt-dialog-image]').src = piece.dataset.ttImage;
      dialog.querySelector('[data-tt-dialog-image]').alt = `${piece.dataset.ttArt} photographic artwork`;
      dialog.querySelector('h2').textContent = piece.dataset.ttArt;
      dialog.showModal();
    }
    if (event.target.closest('[data-tt-close]')) dialog?.close();
    if (event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }
  });
})();


  } catch(e) { console.error(e); }
})();
})();
